import { render, staticRenderFns } from "./CompanyDirectory.vue?vue&type=template&id=167318a2"
import script from "./CompanyDirectory.vue?vue&type=script&lang=js"
export * from "./CompanyDirectory.vue?vue&type=script&lang=js"
import style0 from "./CompanyDirectory.vue?vue&type=style&index=0&id=167318a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports